// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"646":"ca9aa6e8","2433":"ca9aa6e8","5928":"9e67e7ab","8977":"01cd4d11","8995":"4b573390"}[chunkId] + ".chunk.css";
};